const hasValue = (value) => String(value ?? "").trim() !== "";

export const getLiveWebsiteChargeFlag = (website = {}) => {
  if (String(website.status || "").trim().toLowerCase() !== "live") {
    return "";
  }

  const domains = Array.isArray(website.domains) ? website.domains : [];
  const hasLiveDate = domains.some((domain) =>
    hasValue(domain.design?.liveDate),
  );
  const hasCharge = domains.some(
    (domain) =>
      hasValue(domain.design?.amountToCharge) ||
      hasValue(domain.hosting?.monthlyCharge),
  );

  if (!hasLiveDate && !hasCharge) {
    return "Live website is missing a Live Date and design or hosting charge.";
  }
  if (!hasLiveDate) return "Live website is missing a Live Date.";
  if (!hasCharge) {
    return "Live website is missing a design or hosting charge.";
  }
  return "";
};
